/* eslint-disable import/no-cycle, import/order, import/no-named-as-default --
   Legacy reducer barrel: dozens of slice imports added incrementally over time
   in registration order, not alphabetized. The reducer key + import order has
   carried meaning (matches how each slice was wired into the store) so we
   don't reshuffle on the TS migration. Reorder + dedupe is a separate cleanup. */
import { combineReducers } from 'redux'

import api from 'api'
import { textqlApi } from 'api/textqlApi'
import Appbar from 'slices/appbar/appbarSlice'
import persistentRentalFees from 'slices/pricing/persistentRentalFeesSlice'
import persistentDisposalSites from 'slices/settings/persistentDisposalSitesSlice'
import customerCell from 'slices/customer/customerCellSlice'
import beneficialOwnerContacts from 'slices/customer/beneficialOwnerContacts'
import bulkInvoicePreview from 'slices/billing/bulkInvoicePreviewSlice'
import home from 'slices/home/homeSlice'
import disposalFees from 'slices/pricing/disposalFeesSlice'
import lateFees from 'slices/pricing/lateFeesSlice'
import persistentDisposalFees from 'slices/pricing/persistentDisposalFeesSlice'
import persistentLateFees from 'slices/pricing/persistentLateFeesSlice'
import rentalFeeDialog from 'slices/pricing/rentalFeeDialogSlice'
import rentalFees from 'slices/pricing/rentalFeesSlice'
import bulkAssignStops from 'slices/route/bulkAssignStopsSlice'
import Route from 'slices/route/routeSlice'
import Tags from 'slices/tags/tagsSlice'

import createManualInvoicesSlice from 'slices/billing/createManualInvoicesSlice'
import invoices from 'slices/billing/invoicesSlice'
import payments from 'slices/billing/paymentsSlice'
import paymentBatches from 'slices/billing/paymentBatchesSlice'
import accountsReceivable from 'slices/billing/accountsReceivableSlice'
import createCustomer from 'slices/customer/createCustomerSlice'
import persistentWorkOrdersReviewV2 from 'slices/billing/persistentWorkOrdersReviewV2Slice'
import persistentLateFeeReview from 'slices/billing/persistentLateFeeReviewSlice'
import persistentPaymentBatches from 'slices/billing/persistentPaymentBatchesSlice'
import persistentInvoices from 'slices/billing/persistentInvoicesSlice'
import persistentDisposalTicketsReview from 'slices/billing/persistentDisposalTicketsReviewSlice'
import disposalTicketsReview from 'slices/billing/disposalTicketsReviewSlice'
import invoicesCreationBridge from 'slices/billing/invoicesCreationBridgeSlice'
import CustomerDetails from 'slices/customer/customerDetailsSlice'
import configuredServiceDetails from 'slices/configuredService/configuredServiceDetailsSlice'
import configuredServiceSchedule from 'slices/configuredService/configuredServiceScheduleSlice'
import configuredServiceEvents from 'data/configured-service/configuredServiceEventsSlice'
import Contacts from 'slices/customer/contactsSlice'
import CustomerSideNav from 'slices/customer/CustomerSideNavSlice'
import BillingSideNav from 'slices/billing/BillingSideNavSlice'
import reportingDrawer from 'slices/reporting/reportingDrawerSlice'
import invoiceDetailsDrawer from 'slices/billing/invoiceDetailsDrawerSlice'
import AddRemoveInvoiceDialog from 'slices/groups/AddRemoveInvoiceDialogSlice'
import RemovePaymentDialog from 'slices/groups/RemovePaymentDialogSlice'
import Download from 'slices/download/DownloadSlice'
import PaymentGroups from 'slices/groups/PaymentGroupsSlice'
import masterRoute from 'slices/route/masterRouteSlice'
import masterRouteSearch from 'slices/route/masterRouteSearchSlice'
import routingActions from 'slices/route/routingActionsSlice'
import bulkMoveBetweenRoutes from 'slices/route/bulkMoveBetweenRoutesSlice'
import InvoicePrintableView from 'slices/groups/InvoicePrintableViewSlice'
import bulkMoveBetweenDays from 'slices/route/bulkMoveBetweenDaysSlice'
import bulkUnassignStops from 'slices/route/bulkUnassignStopsSlice'
import bulkResequenceStops from 'slices/route/bulkResequenceStopsSlice'
import bulkChangeContainerLocation from 'slices/route/bulkChangeContainerLocationSlice'
import snapToRoad from 'slices/route/snapToRoadSlice'
import bulkPermanentRecurrenceChange from 'slices/route/bulkPermanentRecurrenceChangeSlice'
import persistentMapPreferences from 'slices/route/persistentMapPreferencesSlice'
import persistentOptimizationJobs from 'slices/route/persistentOptimizationJobsSlice'
import bulkRouteOptimization from 'slices/route/bulkRouteOptimizationSlice'
import agingBucket from 'slices/billing/agingBucketSlice'
import createInvoicesSlice from 'slices/billing/createInvoicesSlice'
import suspensionGroups from 'slices/customer/suspensionGroupsSlice'
import accounts from 'slices/customer/accountsSlice'
import responseSlice from 'slices/response/responseSlice'
import pricingDrawer from 'slices/pricing/pricingDrawerSlice'
import notificationDrawer from 'slices/notification-center/notificationDrawerSlice'
import LoginPersist from 'slices/login/LoginPersistSlice'
import createDraftCSD from 'slices/configuredService/createDraftCSDSlice'
import persistentCustomerDetailsServices from 'slices/customer/persistentCustomerDetailsServicesSlice'
import customerDetailsLocations from 'slices/customer/customerDetailsLocationsSlice'
import persistentCustomerDetailsLocations from 'slices/customer/persistentCustomerDetailsLocationsSlice'
import persistentMasterRoute from 'slices/route/persistentMasterRouteSlice'
import persistentBoardV2Card from 'slices/route/persistentBoardV2CardSlice'
import persistentBoardV2View from 'slices/route/persistentBoardV2ViewSlice'
import persistentListView from 'slices/route/persistentListViewSlice'
import persistentRouteViewPref from 'slices/route/persistentRouteViewPrefSlice'
import boardV2Bulk from 'slices/route/boardV2BulkSlice'
import masterRoutePreview from 'slices/route/masterRoutePreviewSlice'
import routeOptimization from 'slices/route/optimizationSlice'
import routeProductivity from 'slices/route/routeProductivitySlice'
import routeProductivityDraft from 'slices/route/routeProductivityDraftSlice'
import routeProductivityMoves from 'slices/route/routeProductivityMovesSlice'
import persistentRouteProductivityColumns from 'slices/route/persistentRouteProductivityColumnsSlice'
import inventoryDrawer from 'slices/Inventory/inventoryDrawerSlice'
import inventoryContainers from 'slices/Inventory/inventoryContainersSlice'
import persistentInventoryContainers from 'slices/Inventory/persistentInventoryContainersSlice'
import locations from 'slices/locations/locationsSlice'
import PricingFiltersMetaSlice from 'slices/meta/pricingFiltersMetaSlice'
import persistentRouteOpsStrategy from 'slices/persistentRouteOpsStrategySlice'
import persistentAiReportsChat from 'slices/ai-reports/persistentAiReportsChatSlice'
import exceptionsFilters from 'slices/exceptions/exceptionsFiltersSlice'
import exceptionsUndo from 'slices/exceptions/exceptionsUndoSlice'
import visionDrawer from 'slices/exceptions/visionDrawerSlice'
import inspectionsFilters from 'slices/inspections/inspectionsFiltersSlice'
import persistentGroupsPageView from 'slices/customer/persistentGroupsPageViewSlice'

import AuthReducer from './AuthReducer'
import BillingReducer from './BillingReducer'
import ConfiguredServicesReducer from './ConfiguredServicesReducer'
import CustomersReducer from './CustomersReducer'
import GlobalSearchReducer from './GlobalSearchReducer'
import PricingReducer from './PricingReducer'
import ResponseReducer from './ResponseReducer'
import RouteManagerReducer from './RouteManagerReducer'

const appReducer = combineReducers({
  AddRemoveInvoiceDialog,
  Appbar,
  AuthReducer,
  beneficialOwnerContacts,
  BillingReducer,
  BillingSideNav,
  reportingDrawer,
  ConfiguredServicesReducer,
  configuredServiceDetails,
  configuredServiceSchedule,
  configuredServiceEvents,
  CustomerDetails,
  Contacts,
  CustomerSideNav,
  CustomersReducer,
  Download,
  GlobalSearchReducer,
  PaymentGroups,
  PricingFiltersMetaSlice,
  PricingReducer,
  RemovePaymentDialog,
  ResponseReducer,
  Route,
  RouteManagerReducer,
  Tags,
  accountsReceivable,
  bulkAssignStops,
  bulkInvoicePreview,
  createCustomer,
  createInvoicesSlice,
  createManualInvoicesSlice,
  invoiceDetailsDrawer,
  invoices,
  invoicesCreationBridge,
  payments,
  paymentBatches,
  persistentWorkOrdersReviewV2,
  persistentLateFeeReview,
  persistentPaymentBatches,
  persistentInvoices,
  persistentDisposalTicketsReview,
  disposalTicketsReview,
  masterRoute,
  masterRouteSearch,
  routingActions,
  bulkMoveBetweenRoutes,
  bulkMoveBetweenDays,
  bulkUnassignStops,
  bulkResequenceStops,
  bulkChangeContainerLocation,
  snapToRoad,
  bulkPermanentRecurrenceChange,
  persistentMapPreferences,
  persistentOptimizationJobs,
  InvoicePrintableView,
  agingBucket,
  suspensionGroups,
  locations,
  accounts,
  home,
  responseSlice,
  pricingDrawer,
  notificationDrawer,
  LoginPersist,
  lateFees,
  rentalFees,
  rentalFeeDialog,
  disposalFees,
  persistentDisposalFees,
  persistentLateFees,
  persistentRentalFees,
  persistentDisposalSites,
  customerCell,
  bulkRouteOptimization,
  createDraftCSD,
  persistentCustomerDetailsServices,
  customerDetailsLocations,
  persistentCustomerDetailsLocations,
  persistentMasterRoute,
  persistentBoardV2Card,
  persistentBoardV2View,
  persistentListView,
  persistentRouteViewPref,
  boardV2Bulk,
  masterRoutePreview,
  routeOptimization,
  routeProductivity,
  routeProductivityDraft,
  routeProductivityMoves,
  persistentRouteProductivityColumns,
  inventoryDrawer,
  inventoryContainers,
  persistentInventoryContainers,
  persistentRouteOpsStrategy,
  persistentAiReportsChat,
  exceptionsFilters,
  exceptionsUndo,
  visionDrawer,
  inspectionsFilters,
  persistentGroupsPageView,
  [api.reducerPath]: api.reducer,
  [textqlApi.reducerPath]: textqlApi.reducer,
})

type AppState = ReturnType<typeof appReducer>
interface AppAction {
  type: string
  [key: string]: unknown
}

const rootReducer = (state: AppState | undefined, action: AppAction): AppState => {
  if (action.type === 'LOGOUT') {
    return appReducer(undefined, action)
  }
  return appReducer(state, action)
}

export default rootReducer
